<!-- 海口定制打印销售售后单 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printSReturnContent" class="print-zone">
            <div class="print-for" style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title-view">
                        <!-- <div class="order-code">
                            <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                            <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                        </div> -->
                        <div v-if="isEditTitle" class="print-title text-color">
                            <el-input type="text" style="width: 70%" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title text-color">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                    </div>
                    <div class="print-orderDetail">
                        <div class="row">
                            <div class="col col-8">
                                <label class="label_r">客户名称：</label>
                                <div class="grid-content">{{ orderData.EntpCusName }}</div>
                            </div>
                            <div class="col col-7">
                                <label class="label_r">退款方式：</label>
                                <div class="grid-content">{{ orderData.PayTypeName }}</div>
                            </div>
                            <div class="col col-6 barfa">
                                <div class="grid-content"><svg id="barcode" /></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-8">
                                <label class="label_r">客户电话：</label>
                                <div class="grid-content">{{ orderData.PhoneNum }}</div>
                            </div>
                            <div class="col col-7">
                                <label class="label_r">是否欠款：</label>
                                <div class="grid-content debts">{{ orderData.IsDebts ? '**' : '' }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-8">
                                <label class="label_r">客户类型：</label>
                                <div class="grid-content">{{ orderData.CusType }}</div>
                            </div>
                            <div class="col col-7">
                                <label class="label_r">退货日期：</label>
                                <div class="grid-content">{{ orderData.ReturnTime }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-8">
                                <label class="label_r">物流公司：</label>
                                <div class="grid-content">{{ orderData.LogisticName }}</div>
                            </div>
                            <div class="col col-7">
                                <label class="label_r">发货方式：</label>
                                <div class="grid-content">{{ orderData.ShipTypeName }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-8">
                                <label class="label_l">销售来源：</label>
                                <div class="grid-content">{{ orderData.CusSourcesName }}</div>
                            </div>                            
                            <div class="col rkCol">
                                <label class="label_r">部门：</label>
                                <div class="grid-content">{{ orderData.OrgName }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-8">
                                <label class="label_r">退货原因：</label>
                                <div class="grid-content">{{ orderData.Reasons }}</div>
                            </div>                            
                            <div class="col rkCol">
                            </div>
                        </div>
                        <div :class="orderData.IsDeduct ? 'row MAnchor' : 'row'">
                            <div v-if="orderData.IsDeduct" class="isModif">冲</div>
                        </div> 
                        <div class="row">
                            <div class="col col-6 barfa_cust">
                                <div class="grid-content"><svg id="barcode_cust" /></div>
                            </div>
                        </div>                                               
                    </div>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse; table-layout: fixed" bordercolor="#333333">
                        <thead class="text-color">
                            <tr style="font-weight: bold">
                                <td width="4%">
                                    <div><b>序</b></div>
                                </td>
                                <td width="14%">
                                    <div><b>编码</b></div>
                                </td>
                                <td width="14%">
                                    <div><b>名称</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>车型</b></div>
                                </td>
                                <td width="9%">
                                    <div><b>规格</b></div>
                                </td>
                                <td width="7%">
                                    <div><b>产地</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>单位</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>数量</b></div>
                                </td>
                                <td width="7%">
                                    <div><b>单价</b></div>
                                </td>
                                <td width="9%">
                                    <div><b>金额</b></div>
                                </td>
                                <td width="9%">
                                    <div><b>备注</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody class="text-color">
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ Number(index) + 1 }}</td>
                                <td>{{ AP.APCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td style="white-space: nowrap; text-overflow: clip; overflow: hidden">{{ AP.AutoSerise }}</td>
                                <td>{{ AP.Size }}</td>
                                <td>{{ AP.Origin }}</td>
                                <td>{{ AP.Unit }}</td>
                                <td>-{{ AP.ReturnCount }}</td>
                                <td>{{ AP.ReturnPrice }}</td>
                                <td>-{{ (AP.ReturnCount * AP.ReturnPrice).toFixed(2) }}</td>
                                <td>{{ AP.Remark }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="10">
                                    <div style="display: inline-block; text-indent: 35px; width: 40%">
                                        <span tdata="pageNO" format="#">第#页</span> / <span tdata="pageCount" format="#">共#页</span>
                                    </div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="8" tdata="SubSum" format="#">小计数量：#</div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="10" tdata="SubSum" format="#,##0.00">小计金额：###</div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div id="foot">
                    <div class="order-remark btd">
                        <div style="width: 57.33333%">人民币大写：{{ capitalAmount }}</div>
                        <div style="width: 16.66667%"></div>
                        <div style="width: 16.66667%">数量：-{{ orderData.TotalCount }}</div>
                        <div style="width: 26.66667%; text-align: right">金额：-{{ orderData.TotalRetrunAmount }}</div>
                        <div style="width: 16.66667%"></div>
                    </div>
                    <!--    脚注    -->
                    <div
                        class="order-remark text-color"
                        slot="content"
                        v-if="(config == null ? false : config.Result && !isEditConfig) || orderData.IsHaveTitleSet"
                        v-html="orderData.IsHaveTitleSet ? orderData.FootNote.replace(/\n/g, '<br/>') : config.RValue.replace(/\n/g, '<br/>')"
                    ></div>
                    <div class="order-setcontent" v-if="isEditConfig">
                        <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                    </div>
                    <div class="order-remark fwb" v-if="!orderData.OrderSName">
                        <div style="width: 16.66667%">开单人：{{ orderData.Creator }}</div>
                        <div style="width: 16.66667%">点货：</div>
                        <div style="width: 16.66667%">验货：</div>
                        <div style="width: 16.66667%">送货：</div>
                    </div>
                    <div class="order-remark fwb" v-else>
                        <div style="width: 16.66667%">开单人：{{ orderData.Creator }}</div>
                        <div style="width: 16.66667%">源开单人：{{ orderData.OrderSName }}</div>
                        <div style="width: 16.66667%">点货：</div>
                        <div style="width: 16.66667%">验货：</div>
                        <div style="width: 16.66667%">送货：</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button class="btn-primary botton-color" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle&& !orderData.IsHaveTitleSet">编辑标题</el-button>
                    <el-button class="btn-primary botton-color" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary botton-color" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig && !orderData.IsHaveTitleSet">编辑脚注</el-button>
                    <el-button class="btn-primary botton-color" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
            </div>
            <div v-if="!isEditConfig" class="re-submit">
                <el-button class="btn-primary botton-color" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary botton-color" @click="printedRecord" v-print="'#printSReturnContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            orderData: {},
            allPrice: 0,
            allNum: 0,
            permission: {},
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {}, //标题配置
            capitalAmount: '',
            imgUrl: '',
            isPrint: false,
            isPreview: false,
            isDefaultSet: false
        };
    },
    watch: {
        orderData(value) {
            if (this.imgUrl || !this.isInit) return;
            this.$nextTick(function () {
                // let canvas = this.$refs.canva;
                // QRCode.toCanvas(
                //     canvas,
                //     value.EntpCusId,
                //     {
                //         width: 80,
                //         height: 80,
                //         margin: 0,
                //         scrollX: 0,
                //         scrollY: 0
                //     },
                //     function () {}
                // );
                // setTimeout(() => {
                //     if (!canvas) return;
                //     html2canvas(canvas, {
                //         width: 80,
                //         height: 80,
                //         scrollX: 0,
                //         scrollY: 0
                //     }).then(canvasRes => {
                //         var imgData = canvasRes.toDataURL('image/png');
                //         this.imgUrl = imgData;
                //         canvas.style.display = 'none';
                //     });
                // }, 1000);
                 JsBarcode('#barcode_cust', value.ReturnCode+'CUST', {
                    width: 1.5,
                    height: 40,
                    fontSize: 14,
                    margin: 0,
                    displayValue: false
                });                   
                JsBarcode('#barcode', value.ReturnCode, {
                    width: 1.1,
                    height: 40,
                    fontSize: 14,
                    margin: 0,
                    displayValue: true
                });
            });
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            this.getConfigByCodes().then(() => {
                this.getSaleOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyxsth', 'dyxsshbt', 'dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyxsth':
                                    this.config = data[i];
                                    break;
                                case 'dyxsshbt':
                                    this.titleConfig = data[i];
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '销售退货单';
                                    break;
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                LODOP.PRINT_INIT('打印销售单退货');

                let topStyle = `
                    .print-title-view {
                        width: 790px;
                        position: relative;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 0;
                        padding-top:37px;
                    }
                    .print-title-view .order-code{
                        display: none;
                    }                    
                    .print-title {
                        margin: 0 auto;
                        text-align: center;
                        font-size: 24px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                        padding-bottom: 5px;
                        position: relative;
                        top: -10px;                       
                    }                    
                    .print-orderDetail {
                        width: 762px;
                        margin-bottom: 10px;
                        font-size: 14px !important;
                        color: #000;
                        padding: 0;
                        padding-left: 5px;
                        margin-right: 20px;
                    }
                    .print-orderDetail .barfa{
                        display:none;
                    }
                    .print-orderDetail .row .barfa_cust{
                        display:none;
                    }                      
                    .print-orderDetail .row {
                        margin-left: -10px;
                        margin-right: -10px;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        margin-bottom: 5px;
                    }

                    .print-orderDetail .row::after,
                    .print-orderDetail .row::before {
                        display: table;
                        content: '';
                        clear: both;
                    }
                    .print-orderDetail .row .col {
                        float: left;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 18px;
                        height: 18px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .print-orderDetail .col-5 {
                        width: 20.83333%;
                    }
                    .print-orderDetail .col-6 {
                        width: 25%;
                    }
                    .print-orderDetail .col-7 {
                        width: 29.16667%;
                    }
                    .print-orderDetail .col-8 {
                        width: 33.33333%
                    }
                    .print-orderDetail .col-9 {
                        width: 37.5%;
                    }   
                    .print-orderDetail .row .height40 {
                        height: 40px !important;
                    }

                    .print-orderDetail .row .col .label_l {
                        width: 70px;
                        text-align: left;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .print-orderDetail .row .col .label_r {
                        width: 70px;
                        text-align: right;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .w60{width:60px !important;}
                    .print-orderDetail .row .col .grid-content {
                        display: inline-block;
                        min-height: 18px;
                        border-radius: unset;
                        line-height: 18px;
                    } 
                    .print-orderDetail .row .col .debts{
                        padding-top: 3px;
                    }
                    .print-orderDetail .row .col .grid-content::after,
                    .print-orderDetail .row .col .grid-content::before {
                        display: table;
                        content: '';
                        clear: both;
                    } 
                    .print-orderDetail .rkCol{
                        height: auto !important;
                        width: 65%;
                        padding-right: 0px !important;
                        overflow: unset !important;
                        white-space: unset !important;
                        text-overflow: unset !important;
                    }
                    .print-orderDetail .rkCol .grid-content{
                        overflow: hidden !important;
                        word-break: break-all !important;
                        word-wrap: break-word !important;
                        white-space: break-spaces !important;
                        white-space: pre-wrap !important;
                        width: 85% !important;
                    }    
                    .isModif{
                        display: none;
                    }                                    
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    td{
                        word-break: break-all;word-wrap: break-word;
                    }                     
                    table{
                        border-top: solid 1px black;
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;                       
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }                
                `;

                let footStyle = `
                    .order-remark {
                        width: 762px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        padding-top: 3px;
                        color: #000;
                        width: 100%;
                        margin: 0 auto;
                        font-size: 15px;
                    }    
                    .fdzt {
                        font-size: 14px;
                    }                    
                    .fwb {
                        font-weight: bold;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }                                
                `;
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);

                // LODOP.ADD_PRINT_BARCODE(10, 5, 100, 100, 'QRCode', this.orderData.EntpCusId);
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');
                // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                LODOP.ADD_PRINT_BARCODE(70, 530, 220, 60, '128Auto', this.orderData.ReturnCode);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                let contentHeight = document.getElementById('printSReturnContent').clientHeight;
                let topHeight = document.querySelector('#printSReturnContent #top').clientHeight;
                let tableHeight = document.querySelector('#printSReturnContent #table').clientHeight;
                let footHeight = document.querySelector('#printSReturnContent #foot').clientHeight;
                let printTableH = 1080 - topHeight;
                LODOP.ADD_PRINT_BARCODE(topHeight+10, 5, 300, 40, '128Auto', this.orderData.ReturnCode+'CUST');
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                LODOP.SET_PRINT_STYLEA(0,"ShowBarText",0);//设置是否显示下方的文字
                if (this.orderData.IsDeduct) {
                    //画椭圆，因为打印插件不支持css的border-radius 所以这里用了他自身的画图像的接口
                    LODOP.ADD_PRINT_SHAPE(3, topHeight - 0, 655, 41, 27, 'solid', 2, 'black');
                    LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                    LODOP.ADD_PRINT_TEXT(topHeight +8, 670, 41, 41, '冲'); //增加纯文本项
                    LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                }                
                if (contentHeight <= 1080) {
                    // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    //隐藏页尾
                    tableStyle += 'tfoot{display:none;}';
                    // printTableH = 950;
                }
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printSReturnContent #top').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                // LODOP.ADD_PRINT_TABLE(topHeight + 30, 0, '100%', printTableH, `<style>${tableStyle}</style>` + document.getElementById('table').innerHTML);
                LODOP.ADD_PRINT_TABLE(
                    topHeight + 60,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printSReturnContent #table').innerHTML
                );
                // LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 1); //高度包含页头页尾
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${footStyle}</style>` + document.querySelector('#printSReturnContent #foot').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);

                // //设计
                // LODOP.PRINT_DESIGN();
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);

                //预览
                if (this.isPreview) LODOP.PREVIEW();
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 9 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格数据
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetHKOrderDetailForPrint',
                    data: {
                        SReturnId: this.printIds[0]
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let data = res.data;
                    this.orderData = res.data;
                    if (this.orderData.TotalRetrunAmount > 0) this.capitalAmount = this.$util.moneyToCapital(-this.orderData.TotalRetrunAmount);
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        }
    }
};
</script>

<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0;
    .order-code {
        display: inline-block;
        margin-bottom: -30px;
    }
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
    padding-right: 5px;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 3px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
    padding-bottom: 5px;
    position: relative;
    top: -10px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    position: relative;
}
div{
    color: red;
}
.text-color{
    color: red;
}
.text-color td{
    color: red;
}
.print-table-main {
    width: 792px;
    font-size: 14px;

    .div-table-cell {
        overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        word-break: break-all;
        word-wrap: break-word;
        height: auto;
        // line-height: 30px;
        line-height: 25px;
        padding-left: 1px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .tableConten {
        .div-table-cell {
            // line-height: 14px;
            // padding-top: 3px;
            line-height: 14px;
            //上下垂直居中
            display: -webkit-box;
            -webkit-box-orient: horizontal;
            -webkit-box-align: center;
            padding-bottom: 5px;
            padding-top: 5px;
        }
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fdzt {
    font-size: 14px;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
.fwb {
    font-weight: bold;
}
.btd {
    border-bottom: 1px dashed #000;
    font-weight: bold;
}

.print-orderDetail {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
}
.print-orderDetail .row {
    margin-left: -10px;
    margin-right: -10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 2px;
}
.print-orderDetail .row::after,
.print-orderDetail .row::before {
    display: table;
    content: '';
    clear: both;
}

.print-orderDetail .row .col {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 18px;
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.print-orderDetail .col-5 {
    width: 20.83333%;
}
.print-orderDetail .col-6 {
    width: 25%;
}
.print-orderDetail .col-7 {
    width: 29.16667%;
}
.print-orderDetail .col-8 {
    width: 33.33333%;
}
.print-orderDetail .row .height40 {
    height: 40px !important;
}
.print-orderDetail .row .barfa {
    height: auto;
    position: absolute;
    right: 65px;
}
.print-orderDetail .row .barfa_cust{
    position: relative;
    white-space: unset;
    overflow: unset;
    text-overflow: unset;
    height: 40px;
}

.print-orderDetail .row .col .label_l {
    width: 70px;
    text-align: left;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.print-orderDetail .row .col .label_r {
    width: 70px;
    text-align: right;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.w60 {
    width: 60px !important;
}
.print-orderDetail .row .col .grid-content {
    display: inline-block;
    min-height: 18px;
    line-height: 18px;
    border-radius: unset;
}
.print-orderDetail .row .col .debts {
    padding-top: 3px;
}
.print-orderDetail .row .col .grid-content::after,
.print-orderDetail .row .col .grid-content::before {
    display: table;
    content: '';
    clear: both;
}
.print-orderDetail .rkCol {
    height: auto !important;
    width: 65%;
    padding-right: 0px !important;
    overflow: unset !important;
    white-space: unset !important;
    text-overflow: unset !important;
}
.print-orderDetail .rkCol .grid-content {
    overflow: hidden !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    white-space: break-spaces !important;
    width: 85% !important;
}
.MAnchor {
    position: relative;
    padding-bottom: 10px;
}
.isModif {
    text-align: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    -moz-border-radius: 50%;
    padding: 3px 11px;
    color: red;
    border: solid 2px red;
    position: absolute;
    right: 80px;
    bottom: -5px;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
tfoot {
    display: none;
}
</style>
